import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const LegacyPWABlocked = () => import(/* webpackChunkName: "4-feat-legacy-pwa-blocked" */ './LegacyPWABlocked');

export default lazyLoadOnRender({ loader: LegacyPWABlocked });
